import { useLanguage } from "@/contexts/LanguageContext";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Rocket, Loader2 } from "lucide-react";
import { useState } from "react";

interface DemoGuardModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function DemoGuardModal({ open, onOpenChange }: DemoGuardModalProps) {
  const { t } = useLanguage();
  const navigate = useNavigate();
  const { signOut } = useAuth();
  const [loading, setLoading] = useState(false);

  const handleSubscribe = async () => {
    setLoading(true);
    onOpenChange(false);
    try {
      await signOut();
    } catch {
      // Continue even if sign-out fails
    }
    navigate("/auth");
    setLoading(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md text-center">
        <DialogHeader className="items-center">
          <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-primary/10">
            <Rocket className="h-8 w-8 text-primary" />
          </div>
          <DialogTitle className="text-xl">
            {t("أعجبك دلّالي؟", "Liked Dallali?")}
          </DialogTitle>
          <DialogDescription className="text-base leading-relaxed pt-2">
            {t(
              "ابدأ بإدارة عقاراتك فعلياً خلال دقائق.",
              "Start managing your properties for real in minutes."
            )}
          </DialogDescription>
        </DialogHeader>
        <Button onClick={handleSubscribe} size="lg" className="w-full mt-4" disabled={loading}>
          {loading && <Loader2 className="h-5 w-5 animate-spin me-2" />}
          {t("صمم باقتك الآن", "Design Your Package Now")}
        </Button>
      </DialogContent>
    </Dialog>
  );
}
